import { Transaction } from './../../data/Transaction';
import { ExpandedTransaction } from './../../data/ExpandedTransaction';
import { CardholderMerchantTransaction } from './../../data/CardholderMerchantTransaction';
import { CustomerAccount } from 'src/app/data/CustomerAccount';
import { CardholderDetails } from './../../data/CardholderDetails';
import { CardholderUserService } from './../../services/cardholder-user.service';
import { EntitlementService } from './../../services/entitlement.service';
import { Component, OnInit } from '@angular/core';
import { MessageService } from 'src/app/services/message.service';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe, CurrencyPipe } from '@angular/common';
import {CardholderService} from "../../services/cardholder.service";
import {ProfileSearchResult} from "../../data/ProfileSearchResult";

@Component({
  selector: 'app-cardholder-history',
  templateUrl: './cardholder-history.component.html',
  styleUrls: ['./cardholder-history.component.css'],
  providers: [DatePipe, CurrencyPipe]
})
export class CardholderHistoryComponent implements OnInit {
  constructor(
    private calendar: NgbCalendar,
    private entitlementService: EntitlementService,
    private cardholderUserService: CardholderUserService,
    private messageService: MessageService,
    private datePipe: DatePipe,
    private currencyPipe: CurrencyPipe
  ) { }

  cardholderDetails: CardholderDetails;
  chipAccounts: CustomerAccount[] = [];
  selectedChipAccount: CustomerAccount;
  stripAccount: CustomerAccount;
  fullName = '';
  loading = false;
  startDate: NgbDate;
  endDate: NgbDate;
  cardholderMerchantTransactions: CardholderMerchantTransaction[] = [];
  notifications: string[] = [];
  alerts: string[] = [];
  unfilteredTransactions: ExpandedTransaction[] = [];
  transactions: ExpandedTransaction[] = [];
  pagedResults: ExpandedTransaction[] = [];
  itemsPerPage = 25;
  selectedPage = 1;
  totalAmount = 0;
  chipActive = true;
  stripActive = true;
  cardholder: ProfileSearchResult;

  ngOnInit() {
    const tempDate = new Date();
    tempDate.setDate(tempDate.getDate() - 30);
    this.startDate = new NgbDate(
      tempDate.getFullYear(),
      tempDate.getMonth() + 1,
      tempDate.getDate()
    );
    this.endDate = this.calendar.getToday();
    this.fetchCardholderAccountDetails();
  }

  hasEntitlement(entitlement: string) {
    return this.entitlementService.hasEntitlement(entitlement);
  }

  fetchCardholderAccountDetails() {
    this.loading = true; // This will get set to false in fetchTransactionData()
    const that = this;
    this.cardholder = CardholderService.retrieveCardholder();
    if (this.cardholder != null) {
      this.cardholderUserService.getCardholderDetails(this.cardholder.cardNum).subscribe(
        data => {
          this.cardholderDetails = data;
          const identity = this.cardholderDetails.identity;
          this.fullName =
            identity.firstName +
            ' ' +
            (identity.middleName === null ? '' : identity.middleName) +
            ' ' +
            identity.lastName;
          this.cardholderDetails.customerAccounts.forEach(element => {
            if (element.type === 'PAYROLL') {
              this.stripAccount = element;
            } else {
              this.chipAccounts.push(element);
            }
          });

          this.selectedChipAccount = this.chipAccounts[0];

          that.fetchTransactionData(this.cardholder.cardNum);
        },
        error => {
          this.messageService.error(error.error);
          this.loading = false;
        }
      );
    }
    else {
      this.cardholderUserService.getCardholderDetails().subscribe(
        data => {
          this.cardholderDetails = data;
          const identity = this.cardholderDetails.identity;
          this.fullName =
            identity.firstName +
            ' ' +
            (identity.middleName === null ? '' : identity.middleName) +
            ' ' +
            identity.lastName;
          this.cardholderDetails.customerAccounts.forEach(element => {
            if (element.type === 'PAYROLL') {
              this.stripAccount = element;
            } else {
              this.chipAccounts.push(element);
            }
          });

          this.selectedChipAccount = this.chipAccounts[0];

          that.fetchTransactionData(null);
        },
        error => {
          this.messageService.error(error.error);
          this.loading = false;
        }
      );
    }
  }

  fetchTransactionData(merchantCard: string) {
    this.notifications = [];
    this.alerts = [];
    this.loading = true;
    const startDateString =
      this.startDate.month +
      '/' +
      this.startDate.day +
      '/' +
      this.startDate.year;
    const endDateString =
      this.endDate.month + '/' + this.endDate.day + '/' + this.endDate.year;
    if (merchantCard == null && this.cardholder != null) {
      merchantCard = this.cardholder.cardNum;
    }
    this.cardholderUserService
      .getTransactionData(
        '' + this.stripAccount.account + ',' + this.selectedChipAccount.account,
        startDateString,
        endDateString,
        merchantCard
      )
      .subscribe(
        data => {
          this.cardholderMerchantTransactions = [];
          this.unfilteredTransactions = [];
          this.cardholderMerchantTransactions =
            data.cardholderMerchantTransaction;
          this.totalAmount = data.totalAmount;
          data.transactions.forEach((tran: Transaction) => {
            const expTrans = new ExpandedTransaction();
            expTrans.tran = tran;
            expTrans.expanded = false;
            expTrans.acctType =
              tran.account === this.stripAccount.account ? 'Strip' : 'Chip';
            this.unfilteredTransactions.push(expTrans);
            this.publishNotifications(tran);
          });
          this.filterTransactions();
        },
        error => {
          this.messageService.error(error.error);
        },
        () => {
          this.loading = false;
        }
      );
  }

  publishNotifications(tran: Transaction) {
    const tran_type = parseInt(tran.type, 10);
    // let last_strip_tran_index = 0; // Used in commented code below

    // Publish to notification feed based on tran type
    // Payroll availability, refunds
    if (
      tran_type === 37 ||
      tran_type === 40 ||
      tran_type === 54 ||
      tran_type === 235 ||
      tran_type === 248
    ) {
      let message = '';
      const amount = this.currencyPipe.transform(tran.amount);

      switch (tran_type) {
        case 40:
          message =
            'Your payroll in the amount of ' + amount + ' is now available.';
          break;
        case 54:
          message =
            'Your split pay in the amount of ' + amount + ' is now available.';
          break;
        case 37:
        case 235:
          message =
            'You have been issued a refund in the amount of ' +
            amount +
            ' from ' +
            tran.merchantName +
            '.';
          break;
        case 248:
          message =
            'Your split pay in the amount of ' + amount + ' is now available.';
      }
      this.notifications.push(
        this.datePipe.transform(new Date(tran.date), 'mediumDate') +
        ' -- ' +
        message
      );
    }

    /***********************************************************
     *  The following code is only kept for historical purposes - it is broken
     *  but may provide insight if we need to get it working.
     ***********************************************************
    if (tran.acct == this.stripAccount) {
      last_strip_tran_index = i;
    }
    //Publish to warning feed
    if (tran.balance < 0 && (this.transactions[last_strip_tran_index] != null && this.transactions[last_strip_tran_index].balance <= 0) && tran.account == this.stripAccount.account) {
      var message = 'Your strip account is negative ';
      if (tran_type == 232 || tran_type == 244 || tran_type == 9428 || tran_type == 9081 || tran_type == 9111 || tran_type == 9112 || tran_type == 9011 || tran_type == 60 || tran_type == 68 || tran_type == 69) {
        var amount = $filter('currency')(tran.amount);
        switch (tran_type) {
          case 232:
            message += 'due to a Claims Debit of ' + amount + '.';
            break;
          case 244:
            message += 'due to a strip account adjustment of ' + amount + '.';
            break;
          case 9248:
            message += 'due to a reversal of Split Pay funding in the amount of ' + amount + '.';
            break;
          case 9081:
            message += 'due to a reversal of funding from your linked bank account in the amount of ' + amount + '. Please contact your home bank for further information.';
            break;
          case 9111:
            message += 'due to a rejection of funding from your linked bank account in the amount of ' + amount + '. Please contact your home bank for further information.';
            break;
          case 9112:
            message += 'due to a rejection of funding from your linked bank account in the amount of ' + amount + '. Please contact your home bank for further information.';
            break;
          case 9011:
            message += 'due to a rejection of funding from your linked bank account in the amount of ' + amount + '. Please contact your home bank for further information.';
            break;
          case 60:
            message += 'due to a Strip to Chip transaction in the amount of ' + amount + '.';
            break;
          case 68:
            message += 'due to the deduction of a late arriving chip transaction in the amount of ' + amount + ' from your strip. Your existing chip balance was insufficient to cover the purchase.';
            break;
          case 69:
            message += 'due to a Strip to Chip transaction in the amount of ' + amount + '.';
            break;
          default:
            message += '. Please contact your disbursing officer.';
        }
        this.alertCount++;
        this.alerts.push($filter('date')(tran.date, 'mediumDate') + ' -- ' + message);
      }
    }
    */
  }

  changeStartDate(newDate) {
    if (newDate.srcElement) {
      const tempDate = new Date(newDate.srcElement.value);
      this.startDate = new NgbDate(
        tempDate.getFullYear(),
        tempDate.getMonth() + 1,
        tempDate.getDate()
      );
    } else {
      this.startDate = newDate;
    }
    if (this.cardholder != null) {
      this.fetchTransactionData(this.cardholder.cardNum);
    }
    else {
      this.fetchTransactionData(null);
    }
  }

  changeEndDate(newDate) {
    if (newDate.srcElement) {
      const tempDate = new Date(newDate.srcElement.value);
      this.endDate = new NgbDate(
        tempDate.getFullYear(),
        tempDate.getMonth() + 1,
        tempDate.getDate()
      );
    } else {
      this.endDate = newDate;
    }
    if (this.cardholder != null) {
      this.fetchTransactionData(this.cardholder.cardNum);
    }
    else {
      this.fetchTransactionData(null);
    }
  }

  pageSet(page) {
    this.selectedPage = page;
    this.setPagedResults();
  }

  setPagedResults() {
    if (this.transactions.length <= 10) {
      this.pagedResults = this.transactions;
    } else {
      this.pagedResults = this.transactions.slice(
        (this.selectedPage - 1) * this.itemsPerPage,
        (this.selectedPage - 1) * this.itemsPerPage + this.itemsPerPage
      );
    }
  }

  showDetails(expandedTrans: ExpandedTransaction) {
    expandedTrans.c2cDetails = '';
    let details: string[];
    const tranDetails = {};
    details = expandedTrans.tran.typeDescription.split('\n');
    for (let x = 0; x < details.length; x += 2) {
      tranDetails[details[x]] = details[x + 1];
    }

    if (
      expandedTrans.tran.merchantName != null &&
      expandedTrans.tran.merchantName.trim() !== ''
    ) {
      tranDetails['Merchant:'] = expandedTrans.tran.merchantName;
    }

    if (
      expandedTrans.tran.type === '0061' ||
      expandedTrans.tran.type === '0260' ||
      expandedTrans.tran.type === '0331' ||
      expandedTrans.tran.type === '0334'
    ) {
      this.cardholderUserService
        .getC2CDetails(
          this.stripAccount.account,
          expandedTrans.tran.tranSequence,
          expandedTrans.tran.type
        )
        .subscribe(
          (data: Transaction) => {
            expandedTrans.c2cDetails = data.typeDescription;
          },
          () => {
            expandedTrans.c2cDetails = '';
          }
        );
    }
    expandedTrans.tranDetails = tranDetails;
  }

  filterTransactions() {
    this.transactions = [];
    this.unfilteredTransactions.forEach(trans => {
      if (
        (this.stripActive && trans.acctType === 'Strip') ||
        (this.chipActive && trans.acctType === 'Chip')
      ) {
        this.transactions.push(trans);
      }
    });
  }
}
